module.exports = __webpack_public_path__ + "static/media/wizualizacja-13.337f4d50.png";